import { MarkdownParagraph } from './paragraph';

export type TDialogBoxTypes = 'success' | 'warning' | 'error';

export class MarkdownDialogBox extends MarkdownParagraph {
  constructor(text: string, protected level: TDialogBoxTypes = 'success') {
    super(text);
  }

  toString(): string {
    let wrapper = '$$';

    switch (this.level) {
      case 'error':
        wrapper = '!!!';
        break;
      case 'warning':
        wrapper = '!!';
        break;
    }

    return `${wrapper}${this.text}${wrapper}`;
  }
}
